import { render, staticRenderFns } from "./teacherSelfTraining.vue?vue&type=template&id=7a69c1f9"
import script from "./teacherSelfTraining.vue?vue&type=script&lang=js"
export * from "./teacherSelfTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports